import { ModelMethods } from '@/core/ryanada'
import { DomainDTO } from '@/dtos'
import { DomainAcceptedRequestData, DomainRequestData } from '@/http'

export class DomainModel
  implements
    ModelMethods<DomainRequestData, DomainAcceptedRequestData, DomainModel>
{
  private dto: DomainDTO
  private token: string

  constructor(dto: DomainDTO, token: string) {
    this.dto = dto
    this.token = token
  }

  public clone(): DomainModel {
    const dtoCopy = JSON.parse(JSON.stringify(this.dto)) as DomainDTO
    return new DomainModel(dtoCopy, this.token)
  }

  public getRequestData(): DomainRequestData {
    return new DomainRequestData(
      this.dto.name,
      this.dto.period,
      this.dto.idProtection,
      this.dto.dnsManagement,
      this.dto.emailForwarding,
      this.token
    )
  }

  public getAcceptedRequestData(i: string): DomainAcceptedRequestData {
    return new DomainAcceptedRequestData(
      i,
      this.dto.name,
      this.dto.period,
      this.dto.idProtection,
      this.dto.dnsManagement,
      this.dto.emailForwarding,
      this.token
    )
  }

  public get cartIndex(): string {
    return this.dto.cartIndex
  }

  public getName(): string {
    return this.dto.name
  }

  setIdProtection(state: boolean): void {
    this.dto.idProtection = state
  }

  setDnsManagement(state: boolean): void {
    this.dto.dnsManagement = state
  }

  setEmailForwarding(state: boolean): void {
    this.dto.emailForwarding = state
  }

  setPeriod(period: number): void {
    this.dto.period = period
  }

  public get idProtection(): boolean {
    return this.dto.idProtection
  }

  public get dnsManagement(): boolean {
    return this.dto.dnsManagement
  }

  public get emailForwarding(): boolean {
    return this.dto.emailForwarding
  }

  public get period(): number {
    return this.dto.period
  }
}
